import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ComboService,
  SalesOrderService,
} from "../../../services/index";
import { PrintData } from "../../master/print/print";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./salesOrder.html",
})
export class SalesOrderComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  printData;
  activeTab: string = ''; 

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  typeList = ["Order Form", "Open Order"];
  filter = {
    party_id: "",
    party_name: "",
    agent_name: "",
    agent_id: "",
    order_from_date: "",
    order_to_date: "",
    order_type: ""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "so_no",
    orderDir: "asc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("orderTemplate") orderTemplate: TemplateRef<any>;
  @ViewChild("stateTemplate") stateTemplate: TemplateRef<any>;
  @ViewChild("convertionTemplate") convertionTemplate: TemplateRef<any>;
  @ViewChild("barcodeTemplate") barcodeTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    private salesservice: SalesOrderService,
    private combo2Service: Combo2Service,
    private modalService: BsModalService,
    public toasterService: ToasterService,
    private comboservice: ComboService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.getPartyList();
    this.agentCombo();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Party Name",
        prop: "party_name",
        headerClass: "text-center",
        minWidth: 290,
        maxWidth: 290,
        width: 290,
      },
      {
        name: "Agent",
        prop: "agent_name",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 115,
        maxWidth: 115,
        width: 115,
      },
      {
        name: "Order. No",
        prop: "so_no",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Order Date",
        prop: "so_dateformatted",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
      },
      {
        name: "Book NO",
        prop: "book_no",
        headerClass: "text-right",
        cellClass: "text-right",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: true,
      },
      {
        name: "F.Tot",
        prop: "ftotpcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "H.Tot",
        prop: "htotpcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      {
        name: "Tot.Pcs",
        prop: "totpcs",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 60,
        maxWidth: 60,
        width: 60,
      },
      // {
      //   name: "Inv.FTot",
      //   prop: "inv_ftot",
      //   headerClass: "text-center",
      //   cellClass: "text-right",
      //   minWidth: 65,
      //   maxWidth: 65,
      //   width: 65,
      // },
      // {
      //   name: "Inv.HTot",
      //   prop: "inv_htot",
      //   headerClass: "text-center",
      //   cellClass: "text-right",
      //   minWidth: 65,
      //   maxWidth: 65,
      //   width: 65,
      // },
      // {
      //   name: "Inv.TotPcs",
      //   prop: "inv_tot",
      //   headerClass: "text-center",
      //   cellClass: "text-right",
      //   minWidth: 65,
      //   maxWidth: 65,
      //   width: 65,
      // },
      // {
      //   name: "Pend.FTot",
      //   prop: "pend_ftot",
      //   headerClass: "text-center",
      //   cellClass: "text-right",
      //   minWidth: 65,
      //   maxWidth: 65,
      //   width: 65,
      // },
      // {
      //   name: "Pend.HTot",
      //   prop: "pend_htot",
      //   headerClass: "text-center",
      //   cellClass: "text-right",
      //   minWidth: 65,
      //   maxWidth: 65,
      //   width: 65,
      // },
      // {
      //   name: "Pend.TotPcs",
      //   prop: "pend_tot",
      //   headerClass: "text-center",
      //   cellClass: "text-right",
      //   minWidth: 65,
      //   maxWidth: 65,
      //   width: 65,
      // },
      {
        name: "Order Type",
        prop: "order_type",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
        {
        name: "Status",
        prop: "so_approval_status",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 65,
      },
      // {
      //   name: "Verified",
      //   prop: "verify",
      //   headerClass: "text-center",
      //   cellClass: "text-right",
      //   minWidth: 100,
      //   maxWidth: 100,
      //   width: 100,
      // },
      {
        name: "Action",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
      {
        name: "Details",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.orderTemplate,
      },
      {
        name: "Close",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.stateTemplate,
      },
      {
        name: "Scan Barcodes",
        prop: "sno",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        sortable: false,
        cellTemplate: this.barcodeTemplate,
      },
      {
        name: "Convert To OrderForm/CDC",
        prop: "sno",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        sortable: false,
        cellTemplate: this.convertionTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 300);
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  changeTab(){
    this.filterPanel.close();
    this.getOrderList()
  }

  clearFilter(): void {
    this.filter.party_name = "";
    this.filter.party_id = "";
    this.filter.agent_name;
    this.filter.agent_id = "";
    this.filter.order_from_date = "";
    this.filter.order_to_date = "";
    this.activeTab = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    if (this.filter.agent_name == "") {
      this.filter.agent_id = "";
    }
    if (this.filter.party_name == "") {
      this.filter.party_id;
    }
    this.filterPanel.close();
    this.getOrderList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }
  agentCombo() {
    let that = this;

    this.combo2Service.agentCombo().then((res: any) => {
      that.agentList = res.data;
      // console.log("AgentCombo Details Worked Fine")
      // setTimeout(function () {
      //     that.displayAgent('Agent', that.user.params.agent_id);
      // }, 200);
    });
  }
  bsModalRef: BsModalRef;
  printOrder(row) {
    let params = row;
    this.salesservice.printOrder(params).then((res: any) => {
      this.printData = res;

      this.bsModalRef = this.modalService.show(PrintData, {
        keyboard: false,
        ignoreBackdropClick: true,
        class: "compWidth-70",
      });
      this.bsModalRef.content.stkdata = Object.assign({}, row);
      this.bsModalRef.content.printcontent = this.printData;
    });
  }
  updateState(row: any): void {
    row.tabevent = undefined;
    let that = this;
    let params = {
      so_id : row.so_id
    }
    swal({
      title: "Are you sure to Update Status Close?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        that.isLoadMask = that.salesservice
          .updateSalesstate(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getOrderList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "success";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }
  addEditSalesOrder(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.getOrderList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD SALES ORDER",
          title: "ADD SALES ORDER",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          name: "ADD SALES ORDER",
        },
      };
    }  else if (mode == "Convert" || mode == "Convert Order") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "CONVERT ORDER FORM",
          title: "CONVERT ORDER FORM",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          name: "CONVERT ORDER FORM",
        },
      };
    }
     else {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT SALES ORDER",
          title: "EDIT SALES ORDER",
          tabParent: "SALES_PLAN",
          mode: mode,
          data: row,
          name: "EDIT SALES ORDER",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  getPartyList() {
    let params = {
      page: 1,
      start: 0,
      limit: 100,
    };
    this.comboservice.getSalesParty(params).then((res: any) => {
      this.partyList = res;
    });
  }
  onSelectParty(party) {
    this.partyList.forEach((element) => {
      if (party == element.name) {
        this.filter.party_id = element.genLedid;
      }
    });
  }
  onSelectAgent(event) {
    this.filter.agent_id = event.agent_id;
  }
  getOrderList(): void {
    if (this.filter.order_from_date) {
      this.filter.order_from_date = this.datePipe.transform(
        this.filter.order_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.order_to_date) {
      this.filter.order_to_date = this.datePipe.transform(
        this.filter.order_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      wo_type: "Sales",
      order_from_date: this.filter.order_from_date,
      order_to_date: this.filter.order_to_date,
      party_id: this.filter.party_id,
      agent_id: this.filter.agent_id,
      order_type: this.filter.order_type,
      so_approve: this.activeTab ? this.activeTab : ''
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.salesservice
      .salesOrderList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.total;
        that.orderList = res.data;
        for (let i = 0; i < res.data.length; i++) {
          that.orderList[i].so_dateformatted = that.datePipe.transform(
            res.data[i].so_date,
            "dd-MM-yyyy"
          );
        }
      });
  }

  deleteOrder(row: any): void {
    let that = this;
    row.tabevent = undefined;
    let params = {
      so_id: row.so_id,
    };
    swal({
      title: "Are you sure to delete this Order Details?",
      text:
        "You will not be able to recover this Order" + " " + row["so_no"] + "",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.salesservice
          .delsalesOrder(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.getOrderList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/salesOrder/salesOrder.ts